<template>
    <div>
        <tab name="8"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="商品ID" :value="1"></el-option>
                            <el-option label="商品名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="14" :lg="11" :xl="8">                    
					<div class="clearfix timeType">
					    <el-input class="input-with-select fl" size="small">
					        <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
					            <el-option label="下单时间" :value="1"></el-option>
					        </el-select>
					    </el-input>
					    <el-date-picker
					        v-model="params.time"
					        type="datetimerange"
					        range-separator="-"
					        start-placeholder="开始时间"
					        end-placeholder="结束时间"
					        size="small"
					        value-format="yyyy-MM-dd HH:mm:ss"
					        :default-time="['00:00:00', '23:59:59']"
					        style="width: 100%;"
					        unlink-panels
					        >
					    </el-date-picker>
					</div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.goodsCategory" placeholder="请选择" size="small">
                        <el-option label="不限制类别" :value="-1"></el-option>
                        <el-option label="仅看唱片专辑的" :value="1"></el-option>
                        <el-option label="仅看服饰的" :value="2"></el-option>
                        <el-option label="仅看纪念品的" :value="3"></el-option>
                        <el-option label="仅看配饰的" :value="5"></el-option>
                        <el-option label="仅看其他的" :value="4"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sort" placeholder="请选择" size="small">
                        <el-option label="优先展示销售额最多的" :value="1"></el-option>
                        <el-option label="优先展示商品数最多的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button  type="primary"  size="small" @click="viewChart" :disabled="!filter" icon="el-icon-data-analysis">查看图表</el-button>
        </div>
        <template v-if="statistics">
            <div class="page-group-title"><span>汇总统计</span></div>
            <el-table
                :data="statistics"
                border
                style="width: 100%"
                v-loading="fetchStatisticsLoading"
                size="small"
                stripe
            >
               <el-table-column prop="goodsCategoryName" label="类别" :min-width="150"></el-table-column>
               <el-table-column prop="amount" label="总销售额" :min-width="150"></el-table-column>
               <el-table-column prop="goodsNum" label="总商品数" :min-width="150"></el-table-column>
            </el-table>
        </template>
        <div class="page-group-title"><span>统计列表</span></div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
               <el-table-column prop="goodsId" label="商品ID"></el-table-column>
               <el-table-column prop="goodsName" label="商品名称" :min-width="150" show-overflow-tooltip></el-table-column>
               <el-table-column prop="amount" label="销售额" :min-width="100"></el-table-column>
               <el-table-column prop="goodsNum" label="商品数"></el-table-column>
               <el-table-column prop="goodsCategoryName" label="类别"></el-table-column>
                <el-table-column label="操作" fixed="right" :width="100">
                    <template slot-scope="scope">
                        <el-button size="small" type="text" @click="toDate(scope.row)">查看日期明细</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="pageSizeChange"
                @current-change="pageNoChange"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import Tab from './../../components/tab';

export default {
    components:{Tab},
    data(){
        this.defaultParams = {
            searchType: 1,
            searchValue: null,
            timeStart: null,
            timeEnd: null,
            goodsCategory: -1,
            sort: 1,
            pageNo: 1,
            pageSize: this.$pageSizes[0],
			timeType:1
        };

        const params = this.parsing();

        return{
            statistics: null,
            fetchStatisticsLoading: false,
            data: null,
            dataList: null,
            params: {...params},
            listLoading: false,
            filter: null
        }
    },
    created() {
        this.$router.replace({path: '/report/sales/surrounding', query: {...this.$route.query, t: Date.now()}});
        this.getStatistics();
    },
    watch: {
        '$route.query': function() {
            this.getDataList();
        }
    },
    methods:{
        parsing() {
            const {searchType, searchValue, timeStart, timeEnd, goodsCategory, sort, pageNo, pageSize} = {...this.defaultParams, ...this.$route.query};


            return {
                searchType: parseInt(searchType), 
                searchValue, 
                time: timeStart && timeEnd ? [timeStart, timeEnd] : [], 
                goodsCategory: parseInt(goodsCategory),
                sort: parseInt(sort), 
                pageNo: parseInt(pageNo), 
                pageSize: parseInt(pageSize),
				timeType:1
            };
        },
        //获取列表
        async getDataList() {
            const {time, ...params} = this.parsing();
            const [timeStart, timeEnd] = time || [];

            this.listLoading = true;

            const res = await this.$request({
                url: '/sales/goods/goods_list',
                method: 'post',
                data: {...params, timeStart, timeEnd}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.data = result;
            this.dataList = result.result || [];

            this.filter = {...params, timeStart, timeEnd};
        },
         //选择pageSize
        pageSizeChange() {
            if(this.isTimeError()) return;
            this.params.pageNo = 1;
            const {time, ...params} = this.params;
            const [timeStart, timeEnd] = time || [];
            this.$router.replace({path: '/report/sales/surrounding', query: {...params, timeStart, timeEnd, t: Date.now()}});
        },
        pageNoChange() {
            if(this.isTimeError()) return;
            const {time, ...params} = this.params;
            const [timeStart, timeEnd] = time || [];
            this.$router.replace({path: '/report/sales/surrounding', query: {...params, timeStart, timeEnd, t: Date.now()}});
        },
        //搜索
        search() {
            if(this.isTimeError()) return;
            this.params.pageNo = 1;
            const {time, ...params} = this.params;
            const [timeStart, timeEnd] = time || [];
            this.$router.replace({path: '/report/sales/surrounding', query: {...params, timeStart, timeEnd, t: Date.now()}});
            this.getStatistics();
        },
        //重置搜索
        reset() {
            const {timeStart, timeEnd, ...params} = this.defaultParams;
            this.params = {
                ...params,
                time: timeStart && timeEnd ? [timeStart, timeEnd] : [],
            };
            this.$router.replace({path: '/report/sales/surrounding', query: {...params, timeStart, timeEnd, t: Date.now()}});
            this.getStatistics();
        },
        isTimeError() {
            const {time} = this.params;
            const [timeStart, timeEnd] = time || [];

            if(!timeStart || !timeEnd) {
                return false;
            }

            if(new Date(timeEnd).getTime() - new Date(timeStart).getTime() > 730 * 24 * 60 *60 *1000) {
                this.$alert('目前支持查询最多2年的数据', '提示', {confirmButtonText: '确认', type: 'warning', center: true});
                return true;
            }

            return false;
        },
        async getStatistics() {
            const {time, ...params} = this.params;
            const [timeStart, timeEnd] = time || [];


            this.fetchStatisticsLoading = true;

            const res = await this.$request({
                url: '/sales/goods/goods/sum',
                method: 'post',
                data: {...params, timeStart, timeEnd}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.fetchStatisticsLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.statistics = result || [];
        },
        // 查看图表
        async viewChart() {
            const {...filter} = this.filter;
            this.$router.push({path: '/report/sales/surrounding/chart', query: {...filter}});
        },
        toDate(row) {
            const {goodsId} = row;
            const {timeStart, timeEnd} = this.filter;
            this.$router.push({path: '/report/sales/surrounding/date', query: {goodsId, timeStart, timeEnd}});
        }
    }
}
</script>

<style lang="scss" scoped>
.statistics-box{
    margin: 20px 0;
    .el-col{
        text-align: center;
        padding: 8px 0;
        .num{
            font-size: 16px;
            margin-bottom: 5px;
        }
    }
}
</style>